import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EMessageType } from 'src/app/shared/data/response-default.interface';
import { AdminOliveService } from 'src/app/shared/services/admin-olive.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { AuthService } from '../../services/auth.service';
import { KeycloakAuthService } from '../../services/keycloak-auth.service';

/**
 * Volta do Keycloak: troca o code pelo token (PKCE), monta a sessão e segue o mesmo roteamento
 * pós-login da tela de login legada. Qualquer falha volta ao /login sem returnUrl, para a tela
 * esperar o botão em vez de redirecionar de novo (sem loop).
 */
@Component({
  selector: 'app-keycloak-callback',
  standalone: true,
  template: `
    <div class="flex items-center justify-center w-screen h-screen bg-chathams-blue">
      <p class="text-white">Entrando...</p>
    </div>
  `
})
export class KeycloakCallbackComponent implements OnInit {
  constructor(
    private readonly keycloakAuth: KeycloakAuthService,
    private readonly authService: AuthService,
    private readonly adminOliveService: AdminOliveService,
    private readonly toastService: ToastService,
    private readonly router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    try {
      const { user, returnUrl } = await this.keycloakAuth.completeLogin();

      // Aguarda as permissões: o roteamento pós-login decide a página pela lista.
      if (!(await this.authService.applyKeycloakUser(user))) {
        // Conta sem os atributos de admin: as APIs recusariam o token.
        await this.keycloakAuth.userManager.removeUser();
        this.toastService.toast(
          'Sua conta ainda não está disponível neste login. Fale com a Oliv-e.',
          EMessageType.Error
        );
        this.router.navigateByUrl('/login');
        return;
      }

      // "Admin Oliv-e" vem do perfil de acesso: resolve antes de navegar, como no login legado.
      this.adminOliveService.resolver().subscribe(() => this.authService.navegarPosLogin(returnUrl));
    } catch {
      this.toastService.toast('Não foi possível concluir o login. Tente novamente.', EMessageType.Error);
      this.router.navigateByUrl('/login');
    }
  }
}
